<template>
  <div class="timeline-item">
    <div class="timeline-item__left">
      <div class="timeline-item__node">
        <img v-if="_icon" :src="_icon" />
      </div>
      <div class="timeline-item__tail"></div>
    </div>
    <div class="timeline-item__wrapper">
      <div class="timeline-item__content">
        <div class="timeline-item__content__title">
          <slot :item="mode" name="title">
            <span>{{ title || '' }}</span>
          </slot>
        </div>
        <div class="timeline-item__content__description">
          <slot :item="mode" name="description">
            <span>{{ description }}</span>
            <span v-if="avatar || name" style="margin-right: 10px">by</span>
            <img
              v-if="avatar"
              :src="avatar"
              class="timeline-item__content__description_avatar"
            />
            <span
              v-if="!avatar && name"
              class="timeline-item__content__description_avatar"
            >
              U
            </span>
            <span>{{ name }}</span>
          </slot>
        </div>
        <div class="timeline-item__content__body">
          <slot :item="mode"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const LogisticsIcon = require('./icons/Logistics.png')
const RecordsIcon = require('./icons/Records.png')
export default {
  props: {
    type: { type: String, require: true },
    icon: { type: String, default: '' },
    title: { type: String, default: '' },
    time: { type: String, default: '' },
    name: { type: String, default: '' },
    avatar: { type: String, default: '' },
    content: {},
  },
  data() {
    return {
      iconsMap: {
        S: LogisticsIcon,
        D: RecordsIcon,
      },
    }
  },
  computed: {
    mode() {
      return {
        type: this.type,
        title: this.title,
        time: this.time,
        name: this.name,
        avatar: this.avatar,
        content: this.content,
      }
    },
    _icon() {
      return this.icon || this.iconsMap[this.type]
    },
    description() {
      if (!this.time) return ''
      const chapeauMap = {
        S: 'Added',
        D: 'Sent',
      }

      const chapeau = chapeauMap[this.type]
      return [chapeau ? `${chapeau} at` : '', this.time].join(' ')
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.timeline-item {
  position: relative;
  --timeline-width: 1px;
  --timeline-style: dashed;
  --timeline-color: #bbbbbb;
  --timeline-left-width: 40px;
  --timeline-left-padding: 50px;
  --timeline-node-size: 38px;
  --timeline-node-icon-size: 20px;
}
.timeline-item__left {
  position: absolute;
  width: var(--timeline-left-width);
  height: 100%;
}
.timeline-item__node {
  margin: 0 auto;
  width: var(--timeline-node-size);
  height: var(--timeline-node-size);
  border-width: var(--timeline-width);
  border-style: var(--timeline-style);
  border-color: var(--timeline-color);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: var(--timeline-node-icon-size);
    height: var(--timeline-node-icon-size);
  }
}
.timeline-item__tail {
  margin: 0 auto;
  width: 0px;
  height: calc(100% - var(--timeline-node-size));
  border-left-width: var(--timeline-width);
  border-left-style: var(--timeline-style);
  border-left-color: var(--timeline-color);
}

.timeline-item__wrapper {
  padding-left: var(--timeline-left-padding);
}

.timeline-item__content .timeline-item__content__title {
  font-size: 14px;
  color: #101010;
  font-weight: 600;
}
.timeline-item__content .timeline-item__content__description {
  font-size: 12px;
  color: #8f97ad;
}
.timeline-item__content .timeline-item__content__description span,
.timeline-item__content .timeline-item__content__description img {
  margin-right: 5px;
}
.timeline-item__content
  .timeline-item__content__description
  .timeline-item__content__description_avatar {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  background-color: #cccccc;
  color: #fff;
  font-size: 14px;
  cursor: default;
  margin-left: auto;
}
.timeline-item__content__body {
  min-height: 46px;
}

.timeline .timeline-item:last-child {
  .timeline-item__tail {
    display: none;
  }
  .timeline-item__content__body {
    min-height: initial;
  }
}
</style>
